/** Hand back to WordPress: admins only, and only where the server says the hand-back can work
 * (a desk-owned WordPress article that didn't come over in the old-posts import). */
export function offerHandBack(article: { can_hand_back?: boolean }, isAdmin: boolean): boolean {
  return isAdmin && article.can_hand_back === true
}
